import { ApplicationState } from '../..';

export const selectedCaseInsuredPerson = (state: ApplicationState) => state.details.detailsInsuredPerson;
